import React from 'react';
import { Badge, Tooltip } from '@fullstory/components';
import { useIntl } from 'react-intl';

type APIPillProps = {
  tooltipContent?: React.ReactNode;
};

export const APIPill = ({ tooltipContent }: APIPillProps) => {
  const intl = useIntl();
  const apiText = intl.formatMessage({
    defaultMessage: 'API',
    id: 'yQlxsN',
    description: 'A pill specifying that an object was created using the Fullstory API',
  });

  const APIBadge = () => <Badge variant="default-inverse">{apiText}</Badge>;

  return tooltipContent ? (
    <Tooltip placement="right" variant="light" tooltipContent={tooltipContent}>
      <APIBadge />
    </Tooltip>
  ) : (
    <APIBadge />
  );
};
